import { render, staticRenderFns } from "./CameraChildConfirmation.vue?vue&type=template&id=93884742&scoped=true&"
import script from "./CameraChildConfirmation.vue?vue&type=script&lang=ts&"
export * from "./CameraChildConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./CameraChildConfirmation.vue?vue&type=style&index=0&id=93884742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93884742",
  null
  
)

export default component.exports